import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import StatusIconCDS from '@sharedCR/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import {
  getBannerStyles,
  getBannerTextStyles,
  iconStyles,
  textWrapperStyles,
} from './InlineAlertBanner.styles';

// A persistent, non-dismissible banner in the AlertCDS visual language (severity color + icon).
// AlertCDS itself is a Snackbar/toast (auto-hides after 12s) and is not usable for content that
// must stay on screen — e.g. the coexistence notice or the propagation notice on the domain
// settings drawer, or the informational banner on the domains list. See `bin/skynet-cds show
// AlertCDS`; this mirrors its styling (AlertCDS.styles.js) as an inline, always-visible Box.
const InlineAlertBanner = ({ variant, message, title = null, dataTestId = null }) => (
  <Box data-testid={dataTestId} sx={getBannerStyles(variant)}>
    <Box sx={iconStyles}>
      <StatusIconCDS type={variant} />
    </Box>
    <Box sx={textWrapperStyles}>
      {title && (
        <Typography sx={getBannerTextStyles(variant)} variant="bold14">
          {title}
        </Typography>
      )}
      <Typography sx={getBannerTextStyles(variant)} variant="regular14">
        {message}
      </Typography>
    </Box>
  </Box>
);

InlineAlertBanner.propTypes = {
  variant: PropTypes.oneOf(Object.values(StatusEnum)).isRequired,
  message: PropTypes.node.isRequired,
  title: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default memo(InlineAlertBanner);
